<h1 mat-dialog-title>{{ 'articleremovedialog.title' | transloco }}</h1>
<div mat-dialog-content>
  <p>{{ 'articleremovedialog.article1' | transloco }} <b>{{article.name}}</b> {{ 'articleremovedialog.article2' | transloco }}</p>
</div>
<div mat-dialog-actions class="actions">
  <button mat-button (click)="doAction()">{{ 'articleremovedialog.delete' | transloco }}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{ 'articleremovedialog.cancel' | transloco }}</button>
</div>
